import { render, staticRenderFns } from "./KerstinBilder.vue?vue&type=template&id=63818730"
import script from "./KerstinBilder.vue?vue&type=script&lang=js"
export * from "./KerstinBilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports